import { messageableFactory } from './firebase.adapter';

export class UpdateNotificationsPermissionsMessage extends messageableFactory.create<
  'Update Notifications Permissions Message',
  { permission: typeof Notification.permission }
>('Update Notifications Permissions Message') {}

export type FirebaseMessages = UpdateNotificationsPermissionsMessage;
